const translations = {
  // Hero Section
  'hero.name': 'JORDAN DESTIN',
  'hero.tagline': 'Award-Winning Actor & Performer',
  'hero.cta': 'View Demo Reel',
  
  // Demo Reel
  'reel.title': 'Demo Reel',
  'reel.subtitle': 'A showcase of my recent work across film, television, and theater',
  'reel.download': 'Download Reel',
  'reel.fullscreen': 'View Fullscreen',
  
  // Press
  'press.title': 'Press & Recognition',
  'press.quote': 'Sterling delivers a powerhouse performance that commands attention in every scene.',
  'press.source': 'The Hollywood Reporter',
  
  // Bio
  'bio.title': 'Biography',
  'bio.content': 'Alexandra Sterling is an award-winning actor known for her versatility and emotional depth. With over a decade of experience across film, television, and theater, she has captivated audiences with memorable performances ranging from intense dramatic roles to nuanced character work. Born and raised in New York City, Alexandra trained at the prestigious Juilliard School before making her professional debut on Broadway. Her breakthrough came with her critically acclaimed performance in "Echoes of Tomorrow," which earned her a Screen Actors Guild nomination. Since then, she has worked with renowned directors and appeared in numerous acclaimed productions. When not on set, Alexandra is passionate about mentoring young actors and supporting arts education programs in underserved communities.',
  'bio.height': 'Height',
  'bio.eyes': 'Eyes',
  'bio.hair': 'Hair',
  'bio.training': 'Training & Skills',
  
  // Gallery
  'gallery.title': 'Photo Gallery',
  'gallery.all': 'All',
  'gallery.headshots': 'Headshots',
  'gallery.production': 'Production Stills',
  'gallery.bts': 'Behind the Scenes',
  
  // Contact
  'contact.title': 'Get In Touch',
  'contact.representation': 'Representation',
  'contact.theatrical': 'Theatrical',
  'contact.commercial': 'Commercial',
  'contact.publicist': 'Publicist',
  'contact.follow': 'Follow',
  'contact.rights': 'All Rights Reserved',
};

export default translations;